import SimpleStore from '../../store/SimpleStore';
import { getLocalStorage, setLocalStorage } from '../browserStorageHandler';
import { parseJwt } from '../common';
import { HTTP_HEADER_KEYS } from '../constants/HttpMethodsConstants';
import {
  EXPIRES_IN,
  REFRESH_TOKEN,
  USER_ID,
  USER_TOKEN
} from '../constants/localStorageConstants';

export const setUserTokenInLS = (userToken: string) => {
  setLocalStorage(USER_TOKEN, userToken);
  SimpleStore.set(HTTP_HEADER_KEYS.AUTHORIZATION, userToken);
};

export const getUserTokenFromLS = () => {
  const userToken = getLocalStorage(USER_TOKEN);
  if (userToken) {
    return userToken;
  }
  return '';
};

export const setUserTokenExpiryInLS = (userTokenExpiryTime: number) => {
  setLocalStorage(
    EXPIRES_IN,
    Math.floor(new Date().getTime() / 1000) + userTokenExpiryTime
  );
};

export const setRefreshTokenInLS = (refreshToken: string) => {
  setLocalStorage(REFRESH_TOKEN, refreshToken);
};

export const setUserIDInLS = (token: string) => {
  try {
    const userId = parseJwt(token)?.user_id;
    if (userId) {
      setLocalStorage(USER_ID, userId);
    } else {
      console.error('Error parsing JWT or extracting userId');
    }
  } catch (error) {
    console.error('Error setting USER_ID as ID in localStorage:', error);
  }
};
